import * as React from "react";
import Loadable from "react-loadable";

export const CreateCompany = Loadable({
  loader: () =>
    import("../../../modules/create-company").then((module) => module.OnboardingCreateCompanyForm) as Promise<any>,
  loading: () => <div className="subtitle">Loading...</div>,
});
